import { Field } from "../Models/Field";
import { InputTextControl, SelectControl } from "./index";
import { FieldType } from "../Enum/FieldType";
import Control from "./Control";
import { InputTextType } from "../Enum/InputTextType";
export default class InputPhoneNumberControl extends Control {
    constructor(field, countryCodes) {
        super(field);
        this.countryCodePattern = /\(\+(\d+)\)/;
        this.initialCountryCode = null;
        this.initialPhoneNumber = "";
        this.countryCodes = countryCodes;
    }
    renderField() {
        if (this.initialValue) {
            let phoneNumber, countryCode;
            [countryCode, ...phoneNumber] = this.initialValue.split(" ");
            this.initialCountryCode = { valueId: countryCode };
            this.initialPhoneNumber = phoneNumber.join(" ");
        }
        return `<div class=phone-control data-main id="${this.field.internalId}">${this.renderCountryCodes()} ${this.renderNumberInput()}</div>`;
    }
    extractCountryCode(input) {
        const matches = input.match(this.countryCodePattern);
        if (matches && matches.length >= 2) {
            return matches[1]; // The first capture group contains the country code
        }
        return null; // Return null if no match is found
    }
    renderCountryCodes() {
        const field = new Field();
        field.internalId = this.field.internalId + "-country-codes";
        field.fieldType = FieldType.Selection;
        field.selectionFieldSettings = {
            options: [],
            listOfValuesId: null,
            allowCustomValue: null,
        };
        field.placeHolder = "Country Code";
        field.selectionFieldSettings.options = this.countryCodes.map((c) => ({
            optionId: this.extractCountryCode(c.phoneCode),
            optionValue: c.phoneCode,
        }));
        const control = new SelectControl(field, false);
        control.initialValue = this.initialCountryCode;
        return control.render();
    }
    renderNumberInput() {
        const field = new Field();
        field.internalId = this.field.internalId + "-phone-number";
        field.fieldType = FieldType.Text;
        field.placeHolder = "1234-4566";
        const control = new InputTextControl(field, false, "^[0-9 -]{1,15}$");
        control.type = InputTextType.tel;
        control.initialValue = this.initialPhoneNumber;
        return control.render();
    }
    getValue() {
        const code = (document.getElementById(this.field.internalId + "-country-codes_select")).value;
        const number = (document.getElementById(this.field.internalId + "-phone-number")).value;
        if (code !== "" && number !== "") {
            return `${code} ${number.replace(/-/, "")}`;
        }
        return null;
    }
}
